import { SUPER_ADMIN_PRODUCT_FEATURES_FETCH_SUCCESS } from '../types';

// State is an object keyed by productName
// { "FlowJo": [...features], "SeqGeq": [...features] }
type ProductFeaturesState = Record<string, unknown[]>;

interface ProductFeaturesAction {
  type?: string;
  productName?: string;
  features?: unknown[];
}

const initialState: ProductFeaturesState = {};

const productFeatures = (
  state: ProductFeaturesState = initialState,
  action: ProductFeaturesAction = {},
): ProductFeaturesState => {
  switch (action.type) {
    case SUPER_ADMIN_PRODUCT_FEATURES_FETCH_SUCCESS:
      return {
        ...state,
        [action.productName as string]: action.features as unknown[],
      };
    default:
      return state;
  }
};

export default productFeatures;
